import React from 'react';
import PropTypes from 'prop-types';

function PageCard({ title, children }) {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            {title
            && (
              <div className="card-header">
                <h5>{title}</h5>
              </div>
            )}
            <div className="card-body datatable-react">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

PageCard.defaultProps = {
  title: null,
};

PageCard.propTypes = {
  title: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
};

export default PageCard;
